import BaseAtomView from 'views/atoms/base-atom-view';
import LocaleHTMLAtomTemplate from './templates/locale-html-atom';
import LocaleService from 'services/loader-handler-services/locale-service';
import Chaplin from 'chaplin';
import { atoms, ModulesToAtomsMap } from 'views/atoms/atoms-module';

const LocaleHTMLAtom = BaseAtomView.extend({
  template: LocaleHTMLAtomTemplate,
  initialize: function () {
    this.listenTo(this, 'addedToDOM', this.load);
    if (this.model.get('locale-features') !== 'styles-and-inline-content') {
      this.model.set('content', [LocaleService.t(this.model.get('locale-key'))]);
      return;
    }
    if (!Array.isArray(this.model.get('merge-items'))) {
      console.warn('The merge-items property must be an array');
      return;
    }
    const string = LocaleService.t(this.model.get('locale-key'));
    const mergeItems = this.model.get('merge-items');
    const mergeCodesRe = mergeItems.map(a => a['merge-code']).join('|');
    const regExp = new RegExp(`\%(${mergeCodesRe})\%`, 'g');
    const content = string.split(regExp).map(item => {
      const content = mergeItems.find(a => a['merge-code'] === item);
      return content || item;
    });
    this.model.set('content', content);
  },
  load() {
    if (!this.model.has('merge-items')) {
      return;
    }
    for (const content of this.model.get('merge-items')) {
      this.registerRegion(
        `atom-${content['merge-code']}-${this.model.cid}`,
        `[data-region="atom-${content['merge-code']}-${this.model.cid}"]`
      );
      const view = atoms[ModulesToAtomsMap[content['mergeable-content']['module-key']]];
      if (!view) {
        console.warn(`No atom view for ${content['mergeable-code']['module-key']} found.`);
        return;
      }
      const model = new Chaplin.Model(content['mergeable-content'][content['mergeable-content']['module-key']]);
      model.set('parentView', this);
      this.subview(
        `atom-${content['merge-code']}-${this.model.cid}`,
        new view({
          model,
          region: `atom-${content['merge-code']}-${this.model.cid}`,
        })
      );
    }
  },
});

export default LocaleHTMLAtom;
